import { useState } from 'react'

const UNSET = Symbol('useOnChange.unset')

/**
 * Runs `onChange` during render when `value` changes, including the first time it is set.
 * Prefer this over syncing state in an effect.
 *
 * @see https://react.dev/reference/react/useState#storing-information-from-previous-renders
 */
export const useOnChange = <T>(value: T, onChange: (prevValue: T | undefined) => void): void => {
  const [prevValue, setPrevValue] = useState<T | typeof UNSET>(UNSET)

  if (!Object.is(prevValue, value)) {
    setPrevValue(value)
    onChange(prevValue === UNSET ? undefined : prevValue)
  }
}
